module.exports = new __parcel__URL__("retrospective.1b1ee868.png").toString();